//#region Imports
import { createAction, props } from '@ngrx/store';
import {
    AdminLoginData,
    AuthData,
    AuthError,
    AuthState,
    DBOData,
    OTPData,
    OTPResponse,
    OTPStateData,
    PasswordData,
    PhoneNumberData,
    RoseKeyData,
    SSNData,
    UpdatePasswordData,
    UserData,
    UserInfoData,
} from './../../interfaces';

//#region Actions ids

enum AuthDataActionIds {
    loadAuthData = '[Auth Data] Load Auth Data',
    loginAction = '[Auth Data] Is Loaded Auth Data',
    OTPAction = '[Auth Data] OTP Action',
    registerAction = '[Auth Data] Do Register Action',
    resetAuthData = '[Auth Data] Reset Auth Data',
    resetDBO = '[Auth Data] Reset Auth dbo',
    resetError = '[Auth Data] Reset Auth Error',
    resetOTP = '[Auth Data] Reset Auth otp',
    resetPassword = '[Auth Data] Reset Auth pasword',
    resetPhoneNumber = '[Auth Data] Reset Auth phone number',
    resetRoseKey = '[Auth Data] Reset Auth rose key',
    resetSSN = '[Auth Data] Reset Auth ssn',
    setAuthData = '[Auth Data] Set Auth Data',
    setDBO = '[Auth Data] Set Auth dbo Data',
    setIsUserValid = '[Auth Data] Set Is Valid User',
    setIsOTPValid = '[Auth Data] Set Password Action',
    setIsOTPInvalid = '[Auth Data] Set Password Action Invalid',
    serError = '[Auth Data] Set Auth Error',
    setLogged = '[Auth Data] Set Logged Data',
    setOTPData = '[Auth Data] Set Auth otp Data',
    setPassword = '[Auth Data] Set Auth pasword',
    putPassword = '[Auth Data] Put Auth pasword',
    postUser = '[Auth Data] Post User',
    postUserSuccess = '[Auth Data] Post User Success',
    postUserError = '[Auth Data] Post User Error',
    putPasswordSuccess = '[Auth Data] Put Auth pasword Success',
    putPasswordError = '[Auth Data] Put Auth pasword Error',
    putPasswordReset = '[Auth Data] Put Auth pasword Reset',
    setPhoneNumberData = '[Auth Data] Set Auth phone number',
    setRoseKey = '[Auth Data] Set Auth Rose Key',
    setSSN = '[Auth Data] Set Auth ssn',
    setUserIdentity = '[Auth Data] Set User Identity',
    validateLogedUser = '[Auth Data] Validate Loged User',
    adminLoginAction = '[Auth Data] Admin Login Action',
    setIsAdmin = '[Auth Data] Set Is Admin',
    loadCustomerData = '[Auth Data] Load Customer Data',
    removeCustomerData = '[Auth Data] Remove Customer Data',
    resetAdminAuthData = '[Auth Data] Reset Admin Auth Data'
}

//#region Actions Instances

export const IsLoadedAuthDataAction = createAction(
    AuthDataActionIds.loginAction
);

export const LoadAuthDataAction = createAction(AuthDataActionIds.loadAuthData);

/**
 * Sends the SMS code. Forgot password and Create account both start here; which page follows
 * is decided by `userExists` in the validate response, not by the button the user pressed (SNP-241).
 */
export const OTPAction = createAction(AuthDataActionIds.OTPAction);

export const RegisterUserAction = createAction(
    AuthDataActionIds.registerAction
);

export const ResetAuthDataAction = createAction(AuthDataActionIds.resetAuthData);

export const ResetAuthErrorAction = createAction(AuthDataActionIds.resetError);

export const ResetDBODataAction = createAction(AuthDataActionIds.resetDBO);

export const ResetOTPDataAction = createAction(AuthDataActionIds.resetOTP);

export const ResetPasswordDataAction = createAction(
    AuthDataActionIds.resetPassword
);

export const ResetPhoneNumberDataAction = createAction(
    AuthDataActionIds.resetPhoneNumber
);

export const ResetRoseKeyDataAction = createAction(
    AuthDataActionIds.resetRoseKey
);

export const ResetSSNDataAction = createAction(AuthDataActionIds.resetSSN);

export const SetAuthDataAction = createAction(
    AuthDataActionIds.setAuthData,
    props<AuthData>()
);

export const SetAuthErrorAction = createAction(
    AuthDataActionIds.serError,
    props<AuthError>()
);

export const SetLoggedDataAction = createAction(AuthDataActionIds.setLogged);

export const SetDBODataAction = createAction(
    AuthDataActionIds.setDBO,
    props<DBOData>()
);

export const SetIsUserValidAction = createAction(
    AuthDataActionIds.setIsUserValid,
    props<AuthState>()
);

export const SetIsOTPValidAction = createAction(
    AuthDataActionIds.setIsOTPValid,
    props<{ otpData: OTPResponse }>()
);

export const SetIsOtpInvalidAction = createAction(
    AuthDataActionIds.setIsOTPInvalid,
);

export const SetOTPDataAction = createAction(
    AuthDataActionIds.setOTPData,
    props<{ otpData: OTPData }>()
);

export const PostUserAction = createAction(
    AuthDataActionIds.postUser
);

export const PostUserSuccessAction = createAction(
    AuthDataActionIds.postUserSuccess
);

export const PostUserErrorAction = createAction(
    AuthDataActionIds.postUserError,
    props<{ alreadyExists: boolean }>()
);

export const PutPasswordDataAction = createAction(
    AuthDataActionIds.putPassword,
    props<{ passwordData: UpdatePasswordData }>()
);

export const PutPasswordDataSuccessAction = createAction(
    AuthDataActionIds.putPasswordSuccess
);

export const PutPasswordDataErrorAction = createAction(
    AuthDataActionIds.putPasswordError
);

export const PutPasswordDataResetAction = createAction(
    AuthDataActionIds.putPasswordReset
);

export const SetPasswordDataAction = createAction(
    AuthDataActionIds.setPassword,
    props<PasswordData>()
);

export const SetLoginDataAction = createAction(
    AuthDataActionIds.adminLoginAction,
    props<AdminLoginData>()
);

export const SetIsAdmin = createAction(
    AuthDataActionIds.setIsAdmin,
    props<{ isAdmin: boolean }>()
);

export const SetPhoneNumberDataAction = createAction(
    AuthDataActionIds.setPhoneNumberData,
    props<PhoneNumberData>()
);

export const SetRoseKeyDataAction = createAction(
    AuthDataActionIds.setRoseKey,
    props<RoseKeyData>()
);

export const SetSSNDataAction = createAction(
    AuthDataActionIds.setSSN,
    props<SSNData>()
);

export const SetUserIdentityAction = createAction(
    AuthDataActionIds.setUserIdentity,
    props<{ userInfoData: UserInfoData }>()
);

export const ValidateLogedUserAction = createAction(
    AuthDataActionIds.validateLogedUser
);

export const LoadCustomerDataAction = createAction(
    AuthDataActionIds.loadCustomerData,
    props<{ roseKey: string }>()
);

export const RemoveCustomerDataAction = createAction(
    AuthDataActionIds.removeCustomerData
);

export const ResetAdminAuthDataAction = createAction(
    AuthDataActionIds.resetAdminAuthData
);
